import React from 'react';
import { TrendingUpIcon, LayersIcon, ActivityIcon, AlertCircleIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
const barData = [{
  name: 'Emergencia',
  prendas: 450
}, {
  name: 'Quirófano',
  prendas: 380
}, {
  name: 'UCI',
  prendas: 290
}, {
  name: 'Pediatría',
  prendas: 210
}, {
  name: 'Maternidad',
  prendas: 180
}, {
  name: 'Medicina Int.',
  prendas: 150
}];
const lineData = [{
  name: 'Lun',
  total: 1200
}, {
  name: 'Mar',
  total: 1350
}, {
  name: 'Mié',
  total: 1100
}, {
  name: 'Jue',
  total: 1420
}, {
  name: 'Vie',
  total: 1580
}, {
  name: 'Sáb',
  total: 950
}, {
  name: 'Dom',
  total: 820
}];
const recentCollections = [{
  id: 'REC-1042',
  date: 'Hoy, 10:45 AM',
  area: 'Emergencia',
  user: 'Juan Pérez',
  total: 45,
  status: 'Sincronizado'
}, {
  id: 'REC-1041',
  date: 'Hoy, 09:15 AM',
  area: 'UCI',
  user: 'María Gómez',
  total: 28,
  status: 'Sincronizado'
}, {
  id: 'REC-1040',
  date: 'Hoy, 08:30 AM',
  area: 'Quirófano',
  user: 'Carlos Ruiz',
  total: 56,
  status: 'Sincronizado'
}, {
  id: 'REC-1039',
  date: 'Ayer, 04:30 PM',
  area: 'Pediatría',
  user: 'Juan Pérez',
  total: 32,
  status: 'Sincronizado'
}, {
  id: 'REC-1038',
  date: 'Ayer, 02:15 PM',
  area: 'Maternidad',
  user: 'María Gómez',
  total: 41,
  status: 'Sincronizado'
}];
export function Dashboard() {
  return <div className="space-y-6" data-id="element-444">
      {/* Welcome */}
      <div data-id="element-445">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-446">Resumen General</h1>
        <p className="text-gray-500" data-id="element-447">
          Métricas y estado actual de la recolección de prendas.
        </p>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-448">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-449">
          <div className="flex items-center justify-between mb-4" data-id="element-450">
            <h3 className="text-gray-500 font-medium" data-id="element-451">Prendas Hoy</h3>
            <div className="p-2 bg-blue-50 rounded-lg" style={{
            color: '#134073'
          }} data-id="element-452">
              <TrendingUpIcon className="w-5 h-5" data-id="element-453" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-454">
            <span className="text-3xl font-bold text-gray-900" data-id="element-455">347</span>
            <span className="text-sm text-green-600 font-medium mb-1 flex items-center" data-id="element-456">
              +12% vs ayer
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-457">
          <div className="flex items-center justify-between mb-4" data-id="element-458">
            <h3 className="text-gray-500 font-medium" data-id="element-459">Esta Semana</h3>
            <div className="p-2 bg-blue-50 rounded-lg" style={{
            color: '#3d99d2'
          }} data-id="element-460">
              <LayersIcon className="w-5 h-5" data-id="element-461" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-462">
            <span className="text-3xl font-bold text-gray-900" data-id="element-463">1,842</span>
            <span className="text-sm text-gray-500 font-medium mb-1" data-id="element-464">
              prendas
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-465">
          <div className="flex items-center justify-between mb-4" data-id="element-466">
            <h3 className="text-gray-500 font-medium" data-id="element-467">Áreas Activas</h3>
            <div className="p-2 bg-green-50 text-green-600 rounded-lg" data-id="element-468">
              <ActivityIcon className="w-5 h-5" data-id="element-469" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-470">
            <span className="text-3xl font-bold text-gray-900" data-id="element-471">10</span>
            <span className="text-sm text-gray-500 font-medium mb-1" data-id="element-472">
              de 12 totales
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-orange-200 p-6 relative overflow-hidden" data-id="element-473">
          <div className="absolute top-0 right-0 w-2 h-full bg-orange-400" data-id="element-474"></div>
          <div className="flex items-center justify-between mb-4" data-id="element-475">
            <h3 className="text-gray-700 font-medium" data-id="element-476">Pendientes Sync</h3>
            <div className="p-2 bg-orange-100 text-orange-600 rounded-lg" data-id="element-477">
              <AlertCircleIcon className="w-5 h-5" data-id="element-478" />
            </div>
          </div>
          <div className="flex items-end gap-2" data-id="element-479">
            <span className="text-3xl font-bold text-orange-600" data-id="element-480">3</span>
            <span className="text-sm text-gray-500 font-medium mb-1" data-id="element-481">
              dispositivos
            </span>
          </div>
        </div>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-482">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-483">
          <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-484">
            Prendas por Área (Semana)
          </h3>
          <div className="h-72" data-id="element-485">
            <ResponsiveContainer width="100%" height="100%" data-id="element-486">
              <BarChart data={barData} layout="vertical" margin={{
              top: 5,
              right: 30,
              left: 40,
              bottom: 5
            }} data-id="element-487">
                <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} data-id="element-488" />
                <XAxis type="number" data-id="element-489" />
                <YAxis dataKey="name" type="category" width={100} tick={{
                fontSize: 12
              }} data-id="element-490" />
                <Tooltip cursor={{
                fill: '#f3f4f6'
              }} data-id="element-491" />
                <Bar dataKey="prendas" fill="#134073" radius={[0, 4, 4, 0]} barSize={20} data-id="element-492" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-493">
          <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-494">
            Tendencia de Recolección
          </h3>
          <div className="h-72" data-id="element-495">
            <ResponsiveContainer width="100%" height="100%" data-id="element-496">
              <LineChart data={lineData} margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-497">
                <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-498" />
                <XAxis dataKey="name" data-id="element-499" />
                <YAxis data-id="element-500" />
                <Tooltip data-id="element-501" />
                <Line type="monotone" dataKey="total" stroke="#3d99d2" strokeWidth={3} dot={{
                r: 4,
                fill: '#134073'
              }} activeDot={{
                r: 6
              }} data-id="element-502" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Recent Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-503">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-504">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-505">
            Últimas Recolecciones
          </h3>
          <button className="text-sm font-medium hover:underline" style={{
          color: '#3d99d2'
        }} data-id="element-506">
            Ver todas
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-507">
          <table className="w-full text-left border-collapse" data-id="element-508">
            <thead data-id="element-509">
              <tr className="bg-gray-50 text-gray-500 text-sm border-b border-gray-200" data-id="element-510">
                <th className="px-6 py-3 font-medium" data-id="element-511">ID</th>
                <th className="px-6 py-3 font-medium" data-id="element-512">Fecha y Hora</th>
                <th className="px-6 py-3 font-medium" data-id="element-513">Área</th>
                <th className="px-6 py-3 font-medium" data-id="element-514">Recolector</th>
                <th className="px-6 py-3 font-medium" data-id="element-515">Total Prendas</th>
                <th className="px-6 py-3 font-medium" data-id="element-516">Estado</th>
              </tr>
            </thead>
            <tbody className="text-sm" data-id="element-517">
              {recentCollections.map((row, i) => <tr key={i} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-518">
                  <td className="px-6 py-4 font-medium text-gray-900" data-id="element-519">
                    {row.id}
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-520">{row.date}</td>
                  <td className="px-6 py-4 font-medium text-gray-900" data-id="element-521">
                    {row.area}
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-522">{row.user}</td>
                  <td className="px-6 py-4 font-bold" style={{
                color: '#134073'
              }} data-id="element-523">
                    {row.total}
                  </td>
                  <td className="px-6 py-4" data-id="element-524">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-525">
                      {row.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}